import React, { useEffect, useState, useMemo } from "react";
import * as XLSX from "xlsx";
import {  mixGetV1 } from "services/mixin";
import { message } from "antd";
import dayjs from 'dayjs';
interface TableItem {
    id: number | string;
    user: string;
    status: string;
    fullname?: string;
    created_at: number | string;
    phone?: string;
    email?: string;
    showDropdown?: boolean;
}

const Referrals: React.FC = () => {
    const [currentCount] = useState(98);
    const [milestoneSteps] = useState<number[]>([5, 25, 50, 100]);
    const [listData, setListData] = useState<TableItem[]>([]);
    const [totalData, setTotalData] = useState(0);
    const [totalPage, setTotalPage] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchKey, setSearchKey] = useState("");
    const [wait, setWait] = useState(false);
    const maxValue = Math.max(...milestoneSteps); 
    const progressPercent = Math.min((totalData / maxValue) * 100, 100);

    // Giả lập dữ liệu user (bạn thay bằng store thực tế)
    // const user = useMemo(
    //     () =>
    //         JSON.parse(localStorage.getItem("user") || "{}") || {
    //             contact_affiliate: { code: "ABC123" },
    //         },
    //     []
    // );
    const user = useMemo(
        () =>
            JSON.parse(localStorage.getItem("user") || "{}") || {
                code: "ABC123",
            },
        []
    );

    // const maxValue = Math.max(...milestoneSteps);
    // const referralCode = user?.contact_affiliate?.code || user?.code || "";
    const referralCode =user?.contact_affiliate?.code ||user?.code ||
    "";

    const referralLink = `${window.origin}/register/${referralCode}`;
    

    // const referralCode = user?.contact_affiliate?.code || "";
    // const referralLink = `${window.origin}/register/${referralCode}`;

    /** Copy Clipboard */
    const copyTextToClipboard = async (text: string) => {
        try {
            await navigator.clipboard.writeText(text);
            message.success({
                content: "Đã sao chép thành công!",
                style: { fontSize: 16, padding: 10 },
            });
        } catch (error) {
            message.error({
                content: "Trình duyệt không hỗ trợ hoặc domain chưa có SSL!",
                style: { fontSize: 16, padding: 10 },
            });
        }
    };

    /** Export Excel */
    const handleExport = () => {
        setWait(true);
        const ws = XLSX.utils.json_to_sheet(listData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Referrals");
        XLSX.writeFile(wb, "referrals.xlsx");
        setTimeout(() => setWait(false), 1000);
    };

    /** Fake API data */
    const getListData = async () => {
    const res = await mixGetV1(
        `/api/v1/fe/customers?sort[]=id,desc&page=${currentPage}&limit=10&affiliate_code=${referralCode}&name=${searchKey}`,
    );

    if (res.status) {
        setTotalData(res.data.total);
        setListData(
            res.data.items.map((item: any) => ({
                id: item.id,
                user: item.user || item.fullname,
                fullname: item.first_name,
                status: item.status,
                created_at: item.created_at ? dayjs(item.created_at).format('DD/MM/YYYY HH:mm') : "",
                phone: item.phone,
                email: item.email,
            }))
        );

        // Cập nhật totalPage
        setTotalPage(Math.ceil(res.data.total / 10));
    }
    };


    useEffect(() => {
        if (referralCode) getListData();
    }, [currentPage, searchKey, referralCode]);

    /** Toggle Dropdown trong bảng */
    const toggleDropdown = (id: number | string) => {
        setListData((prev) =>
            prev.map((item) =>
                item.id === id ? { ...item, showDropdown: !item.showDropdown } : item
            )
        );
    };

    return (
        <div className="referrals-content">
            {/* Header */}
            {/* <div className="header-row">
                <h1 className="title">Cùng phát triển</h1>
                <div className="action-buttons">
                    <button className="action-btn">Tài sản tiếp thị</button>
                    <button className="action-btn">Chính sách liên kết</button>
                </div>
            </div> */}

            {/* Group 1 */}
            <div className="group">
                <div className="group-cols">
                    <div className="group-col">
                        <label className="group-label">Referral Code</label>
                        <p className="group-desc">
                            Invites others through this referral code and start earning commissions.
                        </p>
                        <div className="input-row">
                            <input
                                className="input"
                                type="text"
                                value={referralCode}
                                placeholder="Mã giới thiệu của bạn"
                                readOnly
                            />
                            <button
                                className="copy-btn"
                                onClick={() => copyTextToClipboard(referralCode)}
                            >
                                Copy
                            </button>
                        </div>
                    </div>
                    <div className="separator" />
                    <div className="group-col">
                        <label className="group-label">Share The Referral Link</label>
                        <p className="group-desc">
                            You can also share your referral link by copying and sending it to your friends or sharing it on social media.
                        </p>
                        <div className="input-row">
                            <input
                                className="input"
                                type="text"
                                placeholder="Liên kết giới thiệu của bạn"
                                value={referralLink}
                                readOnly
                            />
                            <button
                                className="copy-btn"
                                onClick={() => copyTextToClipboard(referralLink)}
                            >
                                Copy
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Group 2 */}
            <div className="group pb-64px">
                <label className="group-label">
                    Earn more by inviting more people
                </label>
                <p className="group-desc">
                    The more people you bring on board, the greater your earnings. It's that simple!
                </p>

                <div className="milestone-progress">
                    <div className="milestone-labels">
                        <span className="invited-count">Invited ({totalData})</span>
                        {milestoneSteps.map((step, index) => (
                            <span key={index} className="milestone-step-label">
                                {step}
                            </span>
                        ))}
                    </div>
                    <div className="milestone-bar">
                        <div
                            className="milestone-fill"
                            style={{ width: `${progressPercent}%` }}
                        />
                        {milestoneSteps.map((step, index) => (
                            <div
                                key={index}
                                className={`milestone-dot ${currentCount >= step ? "active" : ""
                                    }`}
                                style={{ left: `${(step / maxValue) * 100}%` }}
                            >
                                <span className="milestone-step-number">{step}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Group 3 */}
            <div className="group">
                {/* Search + Export */}
                <div className="search-export">
                    <div className="search-box">
                        <i className="icon-search">
                            <svg
                                width="25"
                                height="24"
                                viewBox="0 0 25 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M15.5 15L21.5 21M10.5 17C6.63401 17 3.5 13.866 3.5 10C3.5 6.13401 6.63401 3 10.5 3C14.366 3 17.5 6.13401 17.5 10C17.5 13.866 14.366 17 10.5 17Z"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </i>
                        <input
                            value={searchKey}
                            onChange={(e) => setSearchKey(e.target.value)}
                            className="search-input"
                            placeholder="Search"
                        />
                    </div>

                    {listData.length > 0 && (
                        <button
                            className="button button-primary-outline cts-export-btn"
                            onClick={handleExport}
                        >
                            {wait ? "Processing" : "Export"}
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M6 21H18M12 3V17M12 17L17 12M12 17L7 12"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </button>
                    )}
                </div>

                {/* Table */}
                <div className="table-wrapper">
                    <table className="referrals-table">
                        <thead>
                            <tr>
                                <th className="text-left">ID</th>
                                <th className="text-left">USER</th>
                                <th>Service package</th>
                                <th>Days Left</th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {listData.map((item) => (
                                <tr key={item.id}>
                                    <td className="text-left">{item.id}</td>
                                    <td className="text-left">{item.fullname }</td>
                                    <td>{item.status || "N/A"}</td>
                                    <td>{item.created_at}</td>
                                    <td>
                                        <div className="dropdown-wrapper">
                                            <button
                                                className={`contact-btn ${item.showDropdown ? "active" : ""
                                                    }`}
                                                onClick={() => toggleDropdown(item.id)}
                                            >
                                                Liên hệ
                                            </button>
                                            {item.showDropdown && (
                                                <div className="dropdown">
                                                    <button onClick={() => toggleDropdown(item.id)}>
                                                        Email
                                                    </button>
                                                    <button onClick={() => toggleDropdown(item.id)}>
                                                        Điện thoại
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination">
                    <div className="showing">
                        Showing:{" "}
                        {totalData > 10
                            ? totalData > currentPage * 10
                                ? currentPage * 10
                                : totalData
                            : totalData}{" "}
                        of {totalData}
                    </div>
                    <div className="pages">
                        <button
                            className="nav-btn"
                            onClick={() =>
                                setCurrentPage((prev) => Math.max(prev - 1, 1))
                            }
                        >
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.0886 15.1576L10.887 11.9997L14.0886 8.8418" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        </button>
                        {Array.from({ length: totalPage }).map((_, index) => (
                            <button
                                key={index}
                                className={`page-btn ${currentPage === index + 1 ? "active" : ""
                                    }`}
                                onClick={() => setCurrentPage(index + 1)}
                            >
                                {index + 1}
                            </button>
                        ))}
                        <button
                            className="nav-btn"
                            onClick={() =>
                                setCurrentPage((prev) => Math.min(prev + 1, totalPage))
                            }
                        >
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.1499 15.1576L14.3515 11.9997L11.1499 8.8418" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Referrals;
